(function($) {
    $(function() {
        $('.form-simulateur').submit(function(){
            var erreur = false;
            
            $('.form-simulateur .obligatoire').each(function(){
                if($(this).val() === ''){
                    $(this).css('border','1px solid #f00');
                    $(this).parent().find('.champ_obligatoire_texte').css('display','inline-block');
                    erreur = true;
                } else {
                    $(this).css('border','1px solid #fff');
                    $(this).parent().find('.champ_obligatoire_texte').css('display','none');
                }
            });
            
            if(erreur === false){
                return true;
            }
            return false;
        });
    });
})(jQuery);